<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isView"
  >
    <el-row>
      <el-col :span="11">
        <el-form-item
          label="企业性质"
          prop="enterpriseCharacter"
          class="font-bold"
        >
          <el-radio-group v-model="form.enterpriseCharacter">
            <el-radio label="国有" />
            <el-radio label="民营" />
            <el-radio label="外资" />
            <el-radio label="合资" />
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item
          label="优质中小企业情况"
          prop="enterpriseSituation"
          class="font-bold"
        >
          <el-radio-group v-model="form.enterpriseSituation">
            <el-radio label="专精特新“小巨人”企业" />
            <el-radio label="专精特新中小企业" />
            <el-radio label="创新型中小企业" />
            <el-radio label="无" />
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22">
        <el-form-item label="企业规模" prop="scaleType" class="font-bold">
          <el-radio-group v-model="form.scaleType">
            <el-radio label="规模以上中小工业企业" />
            <el-radio label="规模以下中小工业企业" />
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      label="所属细分行业"
      prop="segmentedIndustries"
      class="font-bold"
    >
      <el-radio-group v-model="form.segmentedIndustries" class="font-bold">
        <el-radio label="食品制造业" />
        <el-radio label="化学制品及新材料制造业" />
        <el-radio label="钢铁冶炼及加工业" />
        <el-radio label="药品及医疗用品制造业" />
        <el-radio label="汽车零部件配件及其他高端装备制造业" />
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import { updateInfo } from "@/api/enterprise";

export default {
  props: ["info", "isView"],
  data() {
    return {
      form: {},
      rules: {
        enterpriseCharacter: [
          { required: true, message: "请选择企业性质", trigger: "blur" },
        ],
        enterpriseSituation: [
          {
            required: true,
            message: "请选择优质中小企业情况",
            trigger: "blur",
          },
        ],
        scaleType: [
          { required: true, message: "请选择企业规模", trigger: "blur" },
        ],
        segmentedIndustries: [
          { required: true, message: "请选择所属细分行业", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.form = {
      enterpriseCharacter: this.info.enterpriseCharacter || "",
      enterpriseSituation: this.info.enterpriseSituation || "",
      scaleType: this.info.scaleType || "",
      segmentedIndustries: this.info.segmentedIndustries || "",
    };
  },
  methods: {
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          updateInfo(Object.assign({}, this.info, this.form)).then(() => {
            this.$message.success("保存成功");
            this.$emit("save", this.form);
          });
        }
      });
    },
  },
};
</script>
